import { isEmpty } from 'lodash';

export default ({
  field, list, operator, valueIsString,
}) => list && !isEmpty(list) && list.map((item) => ({
  field,
  value: valueIsString ? item : item.value,
  operator,
}));
